export default __webpack_public_path__ + "static/media/photo7.19d773c7.jpg";